// extracted by mini-css-extract-plugin
module.exports = {"NaviCard":"NaviCard--2RP4L","Primary":"Primary--2THIy"};